module.exports = __webpack_public_path__ + "/static/assets/5c81be8fab4f5ed793554698938ff7f8.gif";